<template>
	<div class="page-container">
		<!-- 顶部渐变区域 -->
		<div class="header-bg">
			<div class="header-content flex_c">
				<div class="user-info flex_a" @click="goLogin">
					<div class="avatar flex_d bg_a">
						<img :src="require('@/assets/img/avatar.png')" alt="" class="avatar-img">
					</div>
					<div class="user-info-text">
						{{ isLogin ? user.account : '点击登录' }}
					</div>
				</div>
				<div class="header-actions flex_c">
					<van-icon name="setting-o" @click="goSettings" />
					<van-icon name="chat-o" :dot="isLogin && user.readFinish === 0" @click="goMessages" />
				</div>
			</div>
			<!-- 数据统计 -->
			<div class="stats-row flex_b">
				<div class="stat-item" @click="handleMenu('收益')">
					<div class="stat-value">{{ isLogin ? (user.yesterdayEstimateCommission) : '0' }}</div>
					<div class="stat-label">昨日预估佣金</div>
				</div>
				
				<div class="stat-item" @click="handleMenu('收益')">
					<div class="stat-value">{{ isLogin ? (user.lastMonthCommission) : '0' }}</div>
					<div class="stat-label">上月结算佣金</div>
				</div>
				
				<div class="stat-item" @click="handleMenu('收益')">
					<div class="stat-value">{{ isLogin ? (user.frozenCommission) : '0' }}</div>
					<div class="stat-label">冻结佣金</div>
				</div>
				
				<div class="stat-item" @click="handleMenu('收益')">
					<div class="stat-value">{{ isLogin ? (user.currentMonthCommission) : '0' }}</div>
					<div class="stat-label">本月累计佣金</div>
				</div>
			</div>
		</div>

		<!-- 余额卡片 -->
		<div class="balance-card flex_c">
			<div class="balance-content">
				<div class="balance-label">账户可提现余额 ($)</div>
				<div class="balance-value">{{ isLogin ? (user.withdrawableCommission) : '0' }}</div>
			</div>
			<div class="balance-btn" @click="goWithdraw">
				去提现
			</div>
		</div>

		<!-- 功能入口 -->
		<div class="menu-card flex_b">
			<div class="menu-item" @click="handleMenu('收益')">
				<div class="menu-icon-wrapper">
					<van-icon name="chart-trending-o" />
				</div>
				<div class="menu-text">收益</div>
			</div>
			
			<div class="menu-item" @click="handleMenu('订单')">
				<div class="menu-icon-wrapper">
					<van-icon name="orders-o" />
				</div>
				<div class="menu-text">订单</div>
			</div>
			
			<!-- <div class="menu-item" @click="handleMenu('团队')">
				<div class="menu-icon-wrapper">
					<van-icon name="friends-o" />
				</div>
				<div class="menu-text">团队</div>
			</div>
			
			<div class="menu-item" @click="handleMenu('邀请')">
				<div class="menu-icon-wrapper">
					<van-icon name="envelop-o" />
				</div>
				<div class="menu-text">邀请</div>
			</div> -->
		</div>

		<!-- 常用工具 -->
		<div class="tools-card">
			<div class="tools-title">常用工具</div>
			<div class="tools-row flex_b">
				<!-- <div class="tool-item" @click="handleMenu('找回订单')">
					<div class="tool-icon-wrapper">
						<van-icon name="completed-o" />
					</div>
					<div class="tool-text">找回订单</div>
				</div> -->
				
				<div class="tool-item" @click="handleMenu('上报记录')">
					<div class="tool-icon-wrapper">
						<van-icon name="notes-o" />
					</div>
					<div class="tool-text">上报记录</div>
				</div>
				
				<div class="tool-item" @click="handleMenu('自动下单上报')">
					<div class="tool-icon-wrapper">
						<van-icon name="notes-o" />
					</div>
					<div class="tool-text">批量下单上报记录</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getLoginMember,
		getMineData
	} from '@/apis/api.js'

	export default {
		name: 'Mine',
		data() {
			return {
				isLogin: false,
				user: {},
			}
		},
		activated() {
			this.checkLoginAndLoad()
		},
		methods: {
			checkLoginAndLoad() {
				this.isLogin = !!getLoginMember()
				if (this.isLogin) {
					this.loadData()
				}
			},
			loadData() {
				this.$toast.loading({
					message: '加载中...',
					duration: 0
				})
				getMineData()
					.then(res => {
						this.user = res
					})
					.catch(e => {
						if (e.handled) return
						this.$toast(e.msg || '加载失败')
					})
					.finally(() => {
						this.$toast.clear()
					})
			},
			// 统一登录检查
			requireLogin() {
				if (!getLoginMember()) {
					this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
					return false
				}
				return true
			},
			// 用户头像点击
			goLogin() {
				if (!this.isLogin) {
					this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
				}
			},

			// 设置
			goSettings() {
				if (!this.requireLogin()) return
				this.$router.push('/settings')
			},
			// 消息
			goMessages() {
				if (!this.requireLogin()) return
				const hasUnread = this.user.readFinish === 0
				this.$router.push({ name: 'Messages', params: { hasUnread } })
			},
			// 余额卡片 - 去提现
			goWithdraw() {
				if (!this.requireLogin()) return
				this.$router.push('/withdraw')
			},
			// 功能菜单
			handleMenu(type) {
				if (!this.requireLogin()) return
				switch (type) {
					case '收益':
						this.$router.push('/revenue')
						break
					case '订单':
						this.$router.push('/orders')
						break
					case '团队':
						alert('团队功能待接入')
						break
					case '邀请':
						alert('邀请功能待接入')
						break
					case '找回订单':
						alert('找回订单功能待接入')
						break
					case '上报记录':
						this.$router.push('/submission_records')
						break
					case '自动下单上报':
						this.$router.push('/auto_submission_records')
						break
				}
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-bottom: 48px;

		.header-bg {
			background: linear-gradient(180deg, #EAE3F1 10%, #f6f6f6 100%);
			padding: 20px 14px 20px;

			.header-content {
				margin-bottom: 24px;

				.user-info {
					flex:1;

					.avatar {
						felx:none;
						width: 50px;
						height: 50px;
						border-radius: 50%;
						font-size: 30px;
						color: #fff;
						margin-right: 12px;

						.avatar-img {
							width: 100%;
							height: 100%;
							border-radius: 50%;
							object-fit: cover;
						}
					}

					.user-info-text {
						felx:1;
						color: #333;
						font-size: 15px;
						font-weight: bold;
					}
				}

				.header-actions {
					flex:none;
					width: 70px;
					font-size: 24px;
					color: #000;
				}
			}

			.stats-row {
				width: 100%;

				.stat-item {
					width: 25%;
					text-align: center;

					.stat-value {
						color: #000;
						font-size: 16px;
						font-weight: bold;
					}

					.stat-label {
						margin-top: 4px;
						color: #999;
						font-size: 11px;
					}
				}
			}
		}

		.balance-card {
			margin: 0 14px 14px;
			box-sizing: border-box;
			background: #222;
			border-radius: 10px;
			padding: 18px 14px;

			.balance-content {
				flex:1;
				color: #f9e1ae;

				.balance-label {
					width: 100%;
					font-size: 12px;
				}

				.balance-value {
					margin-top: 8px;
					font-size: 26px;
					font-weight: bold;
				}
			}

			.balance-btn {
				cursor: pointer;
				flex:none;
				width: 60px;
				text-align: center;
				color: #f9e1ae;
				padding: 4px 0;
				border: 1px solid #f9e1ae;
				border-radius: 2px;
				font-size: 13px;
				box-sizing: border-box;
			}
		}

		.menu-card {
			margin: 0 14px 14px;
			box-sizing: border-box;
			background: #fff;
			border-radius: 10px;
			padding: 14px 0;

			.menu-item {
				width: 25%;
				text-align: center;

				.menu-icon-wrapper {
					font-size: 26px;
					color: #333;
					margin-bottom: 6px;
				}

				.menu-text {
					color: #333;
					font-size: 13px;
				}
			}
		}

		.tools-card {
			margin: 0 14px 14px;
			box-sizing: border-box;
			background: #fff;
			border-radius: 10px;

			.tools-title {
				padding: 14px 20px;
				border-bottom: 1px solid #e4e7ed;
				color: #333;
				font-size: 15px;
				font-weight: bold;
			}

			.tools-row {
				padding: 14px 0;

				.tool-item {
					width: 25%;
					text-align: center;

					.tool-icon-wrapper {
						font-size: 26px;
						color: #333;
						margin-bottom: 6px;
					}

					.tool-text {
						color: #333;
						font-size: 13px;
					}
				}
			}
		}
	}
</style>